import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import ContractManagementNav from '../../Common/Navigation/ContractManagementNav';
import AppointeeManagementNav from '../../Common/Navigation/AppointeeManagementNav';
import ReleaseManagementNav from '../../Common/Navigation/ReleaseManagementNav';
import UploadNav from 'Common/Navigation/UploadNav';
import UtilitiesNav from 'Common/Navigation/UtilitiesNav';
import FeatureFlag from '../../Common/FeatureFlag/feature-flag';
import { flags } from '../../Common/FeatureFlag/features';

class HomePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			menuDisplay: 'contract_menu'
		};

		document.title = 'Contract Management - Home'
	}

	render() {
		return (
			<div id="home_pages" className="App">
                <section id="menu_page" className="content">
                    <h3 className="sr-only">Main Menu</h3>
					<Container id="landing_menu" style={{ padding: '5% 0' }}>
						<div className="main-menu-item landing-item" style={{ justifyContent: 'center' }}>
							<ContractManagementNav />
						</div>
						<div className="main-menu-item landing-item" style={{ justifyContent: 'center' }}>
							<AppointeeManagementNav />
						</div>
						<FeatureFlag flag={flags.BP4}>
							<div className="main-menu-item landing-item" style={{ justifyContent: 'center' }}>
								<ReleaseManagementNav />
							</div>
						</FeatureFlag>
						<div className="main-menu-item landing-item" style={{ justifyContent: 'center' }}>
							<UploadNav />
						</div>
						<div className="main-menu-item landing-item" style={{ justifyContent: 'center' }}>
							<UtilitiesNav />
						</div>
					</Container>
				</section>
			</div>
		);
	}
}

export default HomePage;
